import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  paper: {
    position: 'relative',
  },
  isCollapsed: {
    '&::before': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      left: theme.spacing(1),
      right: theme.spacing(1),
      height: theme.spacing(22),
      background: 'linear-gradient(0deg, white 0%, transparent 50%)',
      zIndex: theme.zIndex.mobileStepper,
    },
  },
  buttonWrapper: {
    position: 'absolute',
    left: 0,
    right: 0,
    transform: 'translate3d(0, -12px, 0)',
    textAlign: 'center',
    zIndex: theme.zIndex.mobileStepper + 1,
  },
  applySearchButtonWrapper: {
    [theme.breakpoints.down('xs')]: {
      marginTop: theme.spacing(-4),
    },
  },
}))

export default useStyles
